// extracted by mini-css-extract-plugin
export default {"result":"Table_result__1rP5Z"};